<template>
  <Block type="countDown" class="">
    <Button
      type="lightShort"
      class="accountEmitor j-get-code"
      v-show="!counting"
      @click="countDownEmit"
    >
      <slot></slot>
    </Button>
    <Button type="grayShort" class="countDownBtn" v-show="counting">
      {{ countText }} {{ lessTime }}s
    </Button>
  </Block>
</template>

<script>
import { EventBus } from '../../utiles';
export const START_COUNT_DOWN_EVT = 'startCountDown';
export const COUNT_DOWN_FINISH = 'countDownFinish';
export const REET_STATUS = 'resetScountDownStatus';

export default {
  props: ['type', 'countTime', 'countText'],
  data() {
    return {
      counting: false,
      lessTime: 0,
      countDownTimer: null
    };
  },
  mounted() {
    EventBus.$on(START_COUNT_DOWN_EVT, () => {
      this.doCountDown();
    });

    EventBus.$on(REET_STATUS, () => {
      this.reset();
    });
  },
  methods: {
    reset() {
      clearInterval(this.countDownTimer);
      this.counting = false;
    },
    doCountDown() {
      this.lessTime = this.countTime;
      this.counting = true;
      this.countDownTimer = setInterval(() => {
        if (this.lessTime == 0) {
          clearInterval(this.countDownTimer);
          this.counting = false;
          EventBus.$emit(COUNT_DOWN_FINISH);
        }
        this.lessTime--;
      }, 1000);
    },
    countDownEmit() {
      this.$emit('countDown');
    }
  }
};
</script>
<style lang="scss">
.accountEmitor {
  width: 100%;
  height: 100%;
  color: inherit;
  font-size: inherit;
  line-height: inherit;
}
.countDownBtn {
  @extend .accountEmitor;
  background: #ccc;
}
</style>
